module.exports = __webpack_public_path__ + "static/media/icon-box3.2a96fde6.svg";